// extracted by mini-css-extract-plugin
export default {"container":"IdServiceApp_container__--IIV","main":"IdServiceApp_main__ge2ut"};